import React from 'react';

const SvgPool: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="-4 -4 24 24"
    {...props}
  >
    <path
      fill="#5A636B"
      fillRule="evenodd"
      d="M1.422 1.5a.722.722 0 0 0-.722.722v11.556c0 .399.323.722.722.722h13a.722.722 0 0 0 .722-.722V2.222a.722.722 0 0 0-.722-.722h-13Zm7.552 9.851h1.82V4.65h-1.82v2.485H6.87V4.649H5.05v6.702h1.82V8.62h2.104v2.732Z" // eslint-disable-line max-len
      clipRule="evenodd"
    />
  </svg>
);

export default SvgPool;
